export default {
  BT_HDP: "ハンディキャップ",
  BT_OU: "オーバー/アンダー",
  BT_ML: "マネーライン",
  BT_1X2: "1X2",
  BT_1X2HDP: "3ウェイハンディキャップ",
  BT_CS: "正確なスコア",
  BT_OE: "奇数/偶数",
  BT_DC: "ダブルチャンス",
  BT_HTFT: "ハーフタイム/フルタイム",
  BT_FGLG: "最初のゴール/最後のゴール",
  BT_TG: "総得点",
  BT_OR: "アウトライト",
  BT_ORZ: "アウトライト",

  BT_ANB: "アウェイノーベット",
  BT_BS: "両方/一方/どちらも得点しない",
  BT_CL: "クリーンシート",
  BT_DNB: "引き分けノーベット",
  BT_DNBH: "前半引き分けノーベット",
  BT_HNB: "ホームノーベット",
  BT_TWTN: "無得点勝利",

  BT_HDPF: "FT. ハンディキャップ | FT. HDP",
  BT_OUF: "FT. オーバー/アンダー | FT. O/U",
  BT_MLF: "FT. マネーライン | FT. ML",
  BT_1X2F: "FT. 1X2",
  BT_1X2HDPF: "FT. 3ウェイハンディキャップ",
  BT_CSF: "FT. 正確なスコア",
  BT_OEF: "FT. 奇数/偶数 | FT. O/E",
  BT_DCF: "FT. ダブルチャンス",
  BT_FGLGF: "FT. ファーストゴール/ラストゴール",
  BT_TGF: "FT. 総ゴール",

  BT_HDPH: "HT. ハンディキャップ | HT. HDP",
  BT_OUH: "HT. オーバー/アンダー | HT. O/U",
  BT_MLH: "HT. マネーライン | HT. ML",
  BT_1X2H: "HT. 1X2",
  BT_1X2HDPH: "HT. 3ウェイハンディキャップ",
  BT_CSH: "HT. 正確なスコア",
  BT_OEH: "HT. 奇数/偶数 | HT. O/E",
  BT_DCH: "HT. ダブルチャンス",
  BT_FGLGH: "HT. ファーストゴール/ラストゴール",
  BT_TGH: "HT. 総ゴール",
  BT_O: "オーバー",
  BT_U: "アンダー",
  BT_ODD: "奇数",
  BT_EVEN: "偶数",

  BT_HDPOU: "HDP & OU",
  BT_PARLAY: "ミックスパーレイ",
  BT_FT: "FT. ",
  BT_1H: "HT. ",
  BT_2H: "2H. ",

  BT_FG: "ファーストゴール",
  BT_LG: "ラストゴール",
  BT_HFG: "ホームファーストゴール",
  BT_AFG: "アウェイファーストゴール",
  BT_HLG: "ホームラストゴール",
  BT_ALG: "アウェイラストゴール",
  BT_NG: "ノーゴール",
  BT_HY: "ホーム はい",
  BT_HN: "ホーム いいえ",
  BT_AY: "アウェイ はい",
  BT_AN: "アウェイ いいえ",
  BT_H: "ホーム",
  BT_A: "アウェイ",
  BT_D: "ドロー",
  BT_HD_DC: "ホーム/ドロー",
  BT_HA_DC: "ホーム/アウェイ",
  BT_DA_DC: "ドロー/アウェイ",
  BT_HH: "ホーム/ホーム",
  BT_HD: "ホーム/ドロー",
  BT_HA: "ホーム/アウェイ",
  BT_DH: "ドロー/ホーム",
  BT_DD: "ドロー/ドロー",
  BT_DA: "ドロー/アウェイ",
  BT_AH: "アウェイ/ホーム",
  BT_AD: "アウェイ/ドロー",
  BT_AA: "アウェイ/アウェイ",

  BT_Y: "はい",
  BT_N: "いいえ",

  BT_LIVE: "ライブ",
  BT_HT: "ハーフタイム",
  BT_DELAYED: "遅延",
  BT_PEN: "ペナルティ",

  BT_FT1: "FT.1",
  BT_FT2: "FT.2",
  BT_FTX: "FT.X",
  BT_HT1: "HT.1",
  BT_HT2: "HT.2",
  BT_HTX: "HT.X",

  BT_BOTH: "両方",
  BT_ONE: "1つ",

  BS_HDP: "フルタイムハンディキャップ",
  BS_HDPH: "前半ハンディキャップ",
  BS_OU: "フルタイムオーバー/アンダー",
  BS_OUH: "前半オーバー/アンダー",
  BS_OE: "フルタイム奇数/偶数",
  BS_OEH: "前半奇数/偶数",
  BS_1X2: "フルタイム1X2",
  BS_1X2H: "前半1X2",
  BS_ML: "フルタイムマネーライン",
  BS_MLH: "前半マネーライン",
  BS_1X2HDP: "フルタイム3ウェイハンディキャップ",
  BS_1X2HDPH: "前半3ウェイハンディキャップ",
  BS_CS: "フルタイム正確なスコア",
  BS_CSH: "前半正確なスコア",
  BS_DC: "フルタイムダブルチャンス",
  BS_DCH: "前半ダブルチャンス",
  BS_FGLG: "フルタイム最初/最後のゴール",
  BS_FGLGH: "前半最初/最後のゴール",
  BS_TG: "フルタイム総得点",
  BS_TGH: "前半総得点",
  BS_ANB: "Away No Bet",
  BS_HTFT: "ハーフタイム/フルタイム",
  BS_BS: "両方/一方/どちらも得点しない",
  BS_CL: "クリーンシート",
  BS_DNB: "引き分けノーベット",
  BS_DNBH: "前半引き分けノーベット",
  BS_HNB: "ホームノーベット",
  BS_TWTN: "無得点勝利",
  BS_OR: "アウトライト",
  BS_ORZ: "アウトライト",

  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",
  LOT_FT: "FT",
  LOT_HT: "HT",

  BT_ALLBT: "All Bet Type",

  D_1: "シングルナンバー",
  D_2: "ナンバー & リバース",
  D_3: "ボックス",
  D_4: "アイボックス",
  D_5: "最後の3桁ボックス",
  D_6: "最後の2桁ボックス",

  D_BIG: "ビッグ",
  D_SMALL: "スモール",
  D_AA: "AA",
  D_SA: "A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "K.O. By",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "D",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "勝利",
  GH_1X20: "勝利",
  GH_1X2HDP: "着順/見せる",
  GH_1X2HDP2: "着順",
  GH_1X2HDP4: "見せる",
  GH_OVER: "オーバー (4,5,6)",
  GH_UNDER: "アンダー (1,2,3)",
  GH_ODD: "奇数 (1,3,5)",
  GH_EVEN: "偶数 (2,4,6)",
  GH_OU1: "オーバー (4,5,6)",
  GH_OU2: "アンダー (1,2,3)",
  GH_OE1: "奇数 (1,3,5)",
  GH_OE2: "偶数 (2,4,6)",

  GX_1X2: "勝利",
  GX_1X20: "勝利",
  GX_1X2HDP: "複勝／入着",
  GX_1X2HDP2: "複勝",
  GX_1X2HDP4: "入着",
  GX_OVER: "オーバー (7-12)",
  GX_UNDER: "アンダー (1-6)",
  GX_ODD: "奇数 (1,3,5,7,9,11)",
  GX_EVEN: "偶数 (2,4,6,8,10,12)",
  GX_OU1: "オーバー (7-12)",
  GX_OU2: "アンダー (1-6)",
  GX_OE1: "奇数 (1,3,5,7,9,11)",
  GX_OE2: "偶数 (2,4,6,8,10,12)",

  GC_OU: "O/U",
  GC_OE: "O/E",
  GC_OVER: "オーバー (3,4,5)",
  GC_UNDER: "アンダー (0,1,2)",
  GC_ODD: "奇数 (1,3,5)",
  GC_EVEN: "偶数 (0,2,4)",
  GC_5_0: "5-0",
  GC_4_1: "4-1",
  GC_3_2: "3-2",
  GC_0_5: "0-5",
  GC_1_4: "1-4",
  GC_2_3: "2-3",
  GC_ML0: "第1球",
  GC_1X20: "勝利する",
  GC_ML: "第1球",
  GC_1X2: "勝利する",
  GC_OU1: "オーバー (3,4,5)",
  GC_OU2: "アンダー (0,1,2)",
  GC_OE1: "奇数 (1,3,5)",
  GC_OE2: "偶数 (0,2,4)",

  ROOM_A: "オープン",
  ROOM_0: "アクティブ",
  ROOM_1: "閉鎖",
  ROOM_2: "キャンセル",
  ROOM_3: "終了",
  ROOM_4: "ベット停止",
  ROOM_10: "すべて",

  ROOM_T0: "すべて",
  ROOM_T1: "パブリックルーム",
  ROOM_T2: "プライベートルーム",
  ROOM_T3: "フリールーム",

  joinRoom1: "パブリックルームに参加",
  joinRoom2: "プライベートルームに参加",
  joinRoom3: "フリールームに参加",
  createRoom1: "パブリックルームを作成",
  createRoom2: "プライベートルームを作成",
  createRoom3: "フリールームを作成",
  Champion: "チャンピオン",
  FirstRunnerUp: "ファーストランナーアップ",
  SecondRunnerUp: "セカンドランナーアップ",

  BT_OEHM: "ホーム 奇数/偶数 | ホーム O/E",
  BT_OEHMH: "前半 ホーム 奇数/偶数 | 前半 ホーム O/E",
  BT_OEAW: "アウェイ 奇数/偶数 | アウェイ O/E",
  BT_OEAWH: "前半 アウェイ 奇数/偶数 | 前半 アウェイ O/E",

  BS_OEHM: "後半 ホーム 奇数/偶数 | 後半 ホーム O/E",
  BS_OEHMH: "前半 ホーム 奇数/偶数 | 前半 ホーム O/E",
  BS_OEAW: "後半 アウェイ 奇数/偶数 | 後半 アウェイ O/E",
  BS_OEAWH: "前半 アウェイ 奇数/偶数 | 前半 アウェイ O/E",

  MB_OVER: "オーバー (4,5,6)",
  MB_UNDER: "アンダー (1,2,3)",
  MB_ODD: "奇数 (1,3,5)",
  MB_EVEN: "偶数 (2,4,6)",

  BS_1X2OU: "1X2 + O/U",
  BT_1X2OU: "1X2 + O/U",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "ダブルチャンス + O/U",
  BT_DCOU: "ダブルチャンス + O/U",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "O/U + O/E",
  BT_OUOE: "O/U + O/E",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "前後半 + 奇数/偶数",
  BT_HTFTOE: "前後半 + 奇数/偶数",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "勝利差",
  BT_WM: "勝利差",
  BK_H1: "ホーム 1点差",
  BK_H2: "ホーム 2点差",
  BK_H3Up: "ホーム 3点以上",
  BK_A1: "アウェイ 1点差",
  BK_A2: "アウェイ 2点差",
  BK_A3Up: "アウェイ 3点以上",
  BK_D: "スコア引き分け (0-0除く)",
  BK_NG: "ノーゴール",

  BS_ETG: "正確な合計得点",
  BT_ETG: "正確な合計得点",
  BS_EHTG: "正確なホーム得点数",
  BT_EHTG: "正確なホーム得点数",
  BS_EATG: "正確なアウェイ得点数",
  BT_EATG: "正確なアウェイ得点数",
  BS_ETGH: "前半 正確な合計得点",
  BT_ETGH: "前半 正確な合計得点",
  BS_EHTGH: "前半 正確なホーム得点数",
  BT_EHTGH: "前半 正確なホーム得点数",
  BS_EATGH: "前半 正確なアウェイ得点数",
  BT_EATGH: "前半 正確なアウェイ得点数",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6以上",
  BT_3Up: "3以上",

  BT_CSHTFT: "前後半スコア",
  BS_CSHTFT: "前後半スコア",
  BT_ETGHTFT: "前後半総ゴール",
  BS_ETGHTFT: "前後半総ゴール",

  CF_CS_2_1: "2-1",
  CF_CS_2_0: "2-0",
  CF_CS_0_2: "0-2",
  CF_CS_1_2: "1-2",
  CF_R_1_W: "第1ラウンド勝者",
  CF_R_2_W: "第2ラウンド勝者",
  CF_R_3_W: "第3ラウンド勝者",
  CF_MLHOME: "ホームチームの勝利",
  CF_MLAWAY: "アウェイチームの勝利",
  CF_EVEN: "2回戦制",
  CF_ODD: "3回戦制",
  CF_ML1: "ホームチームの勝利",
  CF_ML2: "アウェイチームの勝利",
  CF_ML: "独立勝利",
  CF_CS: "正確なスコア",
  CF_OE: "奇数/偶数",
  CF_0: "引き分け",
  CF_1: "ホーム",
  CF_2: "アウェイ",
  CF_OE1: "奇数",
  CF_OE2: "偶数",

  MA_CS_3_0: "3-0",
  MA_CS_2_1: "2-1",
  MA_CS_0_3: "0-3",
  MA_CS_1_2: "1-2",
  MA_ML_TW: "チーム勝利",
  MA_O: "オーバー",
  MA_U: "アンダー",
  MA_OE1: "奇数",
  MA_OE2: "偶数",
  MA_ML: "マネーライン",
  MA_CS: "正確なスコア",
  MA_OU: "オーバー/アンダー",
  MA_OE: "奇数/偶数",
  MA_R_1_W: "第1ラウンド勝者",
  MA_R_2_W: "第2ラウンド勝者",
  MA_R_3_W: "第3ラウンド勝者",
  MA_T_3_R: "合計3ラウンド",
  MA_ANY_W_R: "いずれかのラウンドで勝利",
  MA_NO_W_R: "ラウンド勝利なし",
  MA_W_1: "1ラウンド勝利",
  MA_W_2: "2ラウンド勝利",
  MA_PF: "パーフェクト",
  MA_OU1: "オーバー",
  MA_OU2: "アンダー",
  MA_ML1: "ホーム勝利",
  MA_ML2: "アウェイ勝利",
  MA_ML_C_1: "ラウンド勝利",
  MA_ML_C_2: "ラウンド勝利なし",
  
  EF8_R1_1STBOOM: "ラウンド1 ファーストブーム",
  EF8_R2_1STBOOM: "ラウンド2 ファーストブーム",
  EF8_R3_1STBOOM: "ラウンド3 ファーストブーム",
  EF8_0: "-",
  EF8_1: "ホーム",
  EF8_2: "アウェイ",

};